import { string, array, object } from 'yup';

export const ashesValidation = object().shape({
  ashes: array().of(string()).min(1, 'At least one ashes record is required').required('At least one ashes record is required'),
});
